module.exports = __webpack_public_path__ + "img/request.146fddf3.jpg";